module.exports = __webpack_public_path__ + "img/logo.d45c80bc.png";